import React from "react";
import Areas from "./areas";

// const content = [
//     [
//         {
//             title: "Making Content Management Easy and Effective",
//             subTitle: "We Add More Value To Our Web Development Services In Hobart",
//             para: "Our website design in Hobart, Tasmania services are not just providing aesthetic designs and be done with it. The Digital Creative Designs Australia goes beyond being a web design and development agency, we add more value to the development process and the final product",
//             img: "/img/about.png",
//         },
//         {
//             title: "Making Content Management Easy and Effective",
//             subTitle: "Content Management",
//             para: "We prefer to develop websites that the owner can manage easily. Though the content is the main feature of a website and might need expertise in writing, for which we are here too. But we ensure you can efficiently handle the CMS if you want to write and upload simple content.",
//             img: "/img/about.png",
//         },
//         {
//             title: "Ensuring Seamless Responsiveness Across Devices",
//             subTitle: "Responsiveness",
//             para: "We design and develop websites that adapt seamlessly to all screen sizes. This guarantees a smooth user experience on desktops, tablets, and mobile devices. Our responsive designs enhance accessibility and improve engagement. These added responsiveness features help your website perform flawlessly across different platforms.",
//             img: "/img/about.png",
//         },
//         {
//             title: "Enhancing Accessibility for Inclusive Experiences",
//             subTitle: "Accessibility ",
//             para: "Accessibility is often considered a less important feature, but it is a really important one to cater to every type of user and stand better in the eyes of search engines, too. Actually, having an accessible website is vital in a lot of businesses. We will make sure that all of our work is WCAG v2 Level AA compliant by testing it thoroughly.",
//             img: "/img/about.png",
//         },
//         {
//             title: "Optimizing Usability for a Seamless Experience",
//             subTitle: "Usability",
//             para: "This feature comes right after the above two and is equally important. If the website is not user-accessible and does not check the UI/UX boxes, then the user will not be able to find the information they are looking for, hence the bounce rate will increase. We follow all the SOPs to make the site user-friendly.",
//             img: "/img/about.png",
//         },
//         {
//             title: "Personalised Website Design Tailored for Hobart Businesses",
//             subTitle: "Personalised Website Design For Hobart",
//             para: "This feature comes right after the above two and is equally important. If the website is not user-accessible and does not check the UI/UX boxes, then the user will not be able to find the information they are looking for, hence the bounce rate will increase. We follow all the SOPs to make the site user-friendly.",
//             img: "/img/about.png",
//         },
//         {
//             title: "Personalised Website Design Tailored for Hobart Businesses",
//             subTitle: "Future Ready",
//             para: "Like accessibility, we do not let this point go unnoticed, as many clients and website development agencies do because of the added cost. We take money and, as we said, provide value by making your website scalable for future technologies and industry advancements.",
//             img: "/img/about.png",
//         },
//     ]
// ]



function AreasPages({indx, content}) {
    
  return (
    <div style={{margin: "150px 0px"}} className="res-area-pages-container">
    {content.subheading.map((item, index) => (
        <Areas align={index % 2 === 0 ? true : false} content={item}/>
    ))}
    </div>
  );
}

export default AreasPages;
